export default function (initialDataInteractor, organizationId) {
  initialDataInteractor.data.organizations.forEach((organization, index) => {
    if (organization.organization_info.id == organizationId) {
      initialDataInteractor.data.organizations.splice(index, 1);
    }
  });
}